function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

function splider() {

    initSplide('.slide-con', {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: 24,
        pagination: false,
        autoplay: true,
        padding: '5rem',
        breakpoints: {
        1024: {
            autoplay: false,
            perPage: 3,
            perMove: 1,
            rewind: true,
            padding: '4rem',
            focus  : 'center',
            autoplay: true,
            gap: 20,
          },
        767: {
            autoplay: true,
            perPage: 2,
            perMove: 1,
            rewind: true,
            padding: '4rem',
            focus  : 'center',
            autoplay: true,
            gap: 20,
          },
        500: {
            autoplay: true,
            perPage: 1,
            perMove: 1,
            rewind: true,
            padding: '4rem',
            focus  : 'center',
            autoplay: true,
            gap: 20,
          },
        }
    });


}

document.addEventListener('DOMContentLoaded', splider);